module.exports = __webpack_public_path__ + "img/sankaku_47_red.894cd8fb.png";